import ActivityLogTimeline from './activityLogTimeline.container'

export default ActivityLogTimeline